import React from 'react';
import { EntityId } from "@reduxjs/toolkit";
import { useAppSelector } from "src/store/hooks";

import { Image } from "antd";
import { selectImageEntities, selectImageIds } from "src/store/community/imagesSlice";

import Card from "./_Card";

const _ListGrid = () => {
  const ids       = useAppSelector(selectImageIds);
  const images  = useAppSelector(selectImageEntities);

  const renderImage = (id: EntityId) => {
    const image = images[id];

    if (!image) {
      return;
    }

    return <Card image={image} key={`image-${id}`} />;
  }

  return (
    <>
      <Image.PreviewGroup>
        {ids && ids.map(renderImage)}
      </Image.PreviewGroup>
    </>
  );
}

export default _ListGrid;
